import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import ErrorMessage from "../../../../components/comman/ErrorMessage";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import DeleteUnfilledIcon from "../../../../components/Icons/DeleteUnFilledIcon";
import EditIcon from "../../../../components/Icons/EditIcon";
import AddDeductionModal from "../../../../components/comman/AddDeductionModal";
import AddEarningModal from "../../../../components/comman/AddEarningModal";


export default function AddOfficeSalaryHead() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedId, setSelectedId] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedSalaryHeads, setSelectedSalaryHeads] = useState({
    earning: [],
    deduction: [],
  });
  const OfficeSalaryHeadData = location?.state?.OfficeSalaryHeadData || [];
  const existingOfficeIds = OfficeSalaryHeadData?.map((item) => item.id);
  const [modalData, setModalData] = useState({});
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const [earningModal, setEarningModal] = useState(false);
  const toggleEarningModal = () => {
    setEarningModal(!earningModal);
  };
  const [deductionModal, setDeductionModal] = useState(false);
  const toggleDeductionModal = () => {
    setDeductionModal(!deductionModal);
  };
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [pageStates, setPageStates] = useState({
    officeList: [],
    earnings: [],
    deductions: [],
    officeSalaryHeadDetail: [],
    isLoading: false,
  });

  useEffect(() => {
    GetOfficeList();
    GetSalaryHead("earning");
    GetSalaryHead("deduction");
    if (location?.state?.data) {
      GetOfficeSalaryHeadDetail();

      setTimeout(() => {
        reset({
          siteId: location?.state?.data?.id,
        });
      }, 700);
    }
  }, []);

  const selectedOfficeId = watch("siteId");

  const GetOfficeList = (companyId = null) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_site + `?type=office&pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          officeList: response?.data?.site,
        }));
      }
    });
  };

  const GetSalaryHead = (type) => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_salary_head + `pageSize=50&type=${type}`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          ...(type === "earning" && { earnings: res?.data?.salaryHead }),
          ...(type === "deduction" && { deductions: res?.data?.salaryHead }),
        }));
      }
    });
  };

  const GetOfficeSalaryHeadDetail = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_office_salary_head_detail +
      `?siteId=${location?.state?.data?.id}`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        const earning = [];
        const deduction = [];
        for (const item of res.data) {
          if (item?.salaryhead?.type == "earning") {
            earning.push(item);
          } else {
            deduction.push(item);
          }
        }

        setSelectedSalaryHeads((prev) => ({
          ...prev,
          earning: earning,
          deduction: deduction,
        }));
      }
    });
  };

  const handleUpdateSalaryHead = (data, type) => {
    if (type === "earning") {
      setModalData(data);
      toggleEarningModal();
    }
    if (type === "deduction") {
      setModalData(data);
      toggleDeductionModal();
    }
  };

  const handleRemoveSalaryHead = () => {
    const API = `${apiUrl?.delete_office_salary_head}?officeSalaryHeadId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        toast.success(response.message);
        setSelectedSalaryHeads((prev) => ({
          ...prev,
          [selectedType]: prev[selectedType]?.filter(
            (item) => item.id != selectedId
          ),
        }));
        toggleModal();
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (data, type) => {
    setSelectedType(type);
    setSelectedId(data);
    toggleModal();
  };

  const onSubmit = (data) => {
    if (selectedSalaryHeads?.length === 0) {
      toast.info("Please select Earning or Deduction before submit");
      return;
    }
    const submitData = {
      siteId: data?.siteId,
    };

    const options = {
      method: "POST",
      data: submitData,
    };
    let API = location?.state?.data
      ? apiUrl?.update_office_salary_head + `?siteId=${location?.state?.data?.id}`
      : apiUrl?.create_office_salary_head;
    setPageStates((prev) => ({
      ...prev,
      isLoading: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        isLoading: false,
      }));
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(-1);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Add "} Office Salary Head
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-BasicDetails"
                  role="tabpanel"
                  aria-labelledby="pills-BasicDetails-tab"
                  tabIndex={0}
                >
                  <div className="d-flex justify-content-between">
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className="form-group mb-3">
                        <label className="form-label">Office</label>

                        <select
                          className={`form-select form-control ${errors.siteId ? "is-invalid" : ""
                            }`}
                          disabled={location?.state?.data}
                          aria-label="Default select example"
                          {...register("siteId", {
                            required: "This field is Required",
                          })}
                        >
                          <option value="">Select Office</option>
                          {pageStates?.officeList?.length > 0 ? (
                            pageStates?.officeList?.map((item, index) => (
                              <option
                                key={index}
                                value={item?.siteId || item?.id}
                                disabled={existingOfficeIds?.includes(item?.siteId || item?.id)}
                              >
                                {item?.site?.name || item?.name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              No data found
                            </option>
                          )}
                        </select>

                        <ErrorMessage message={errors?.siteId?.message} />
                      </div>
                    </div>

                    <div className="d-flex gap-4 py-5">
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={() => {
                          if (!selectedOfficeId) {
                            toast.info("Please select Office before add earning");
                          } else {
                            setModalData({});
                            toggleEarningModal();
                          }
                        }}
                      >
                        Add Earning
                      </button>
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={() => {
                          if (!selectedOfficeId) {
                            toast.info("Please select Office before add deduction");
                          } else {
                            setModalData({});
                            toggleDeductionModal();
                          }
                        }}
                      >
                        Add Deduction
                      </button>
                    </div>
                  </div>

                  <div className="row my-5">
                    <div className="col-12 col-md-6 mb-4">
                      <div className="border rounded p-3 h-100 bg-success-subtle">
                        <h4 className="text-center mb-3">Earnings</h4>

                        <div className="d-flex flex-column gap-2">
                          {selectedSalaryHeads?.earning?.length <= 0 ? (
                            <div className="text-muted text-center fst-italic">
                              No earnings selected
                            </div>
                          ) : (
                            selectedSalaryHeads?.earning?.map((item) => (
                              <div
                                className="border rounded px-3 py-1 d-flex justify-content-between align-items-center bg-light mx-2"
                                key={item?.id}
                              >
                                <span className="fs-4">{item?.salaryhead?.name}</span>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="bg-transparent border-0 text-black p-0"
                                    onClick={() =>
                                      handleUpdateSalaryHead(
                                        item,
                                        "earning"
                                      )
                                    }
                                  >
                                    <EditIcon />
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-transparent border-0 text-black p-0"
                                    onClick={() =>
                                      ActionHandler(
                                        item?.id,
                                        "earning"
                                      )
                                    }
                                  >
                                    <DeleteUnfilledIcon />
                                  </button>{" "}
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 mb-4">
                      <div className="border rounded p-3 h-100 bg-danger-subtle">
                        <h4 className="text-center mb-3">Deductions</h4>

                        <div className="d-flex flex-column gap-2">
                          {selectedSalaryHeads?.deduction?.length <= 0 ? (
                            <div className="text-muted text-center fst-italic">
                              No deductions selected
                            </div>
                          ) : (
                            selectedSalaryHeads?.deduction?.map((item) => (
                              <div
                                className="border rounded px-3 py-1 d-flex justify-content-between align-items-center bg-light mx-2"
                                key={item?.id}
                              >
                                <span className="fs-4">{item?.salaryhead?.name}</span>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="bg-transparent border-0 text-black p-0"
                                    onClick={() =>
                                      handleUpdateSalaryHead(item, "deduction")
                                    }
                                  >
                                    <EditIcon />
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-transparent border-0 text-black p-0"
                                    onClick={() =>
                                      ActionHandler(
                                        item?.id,
                                        "deduction"
                                      )
                                    }
                                  >
                                    <DeleteUnfilledIcon />
                                  </button>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {!location?.state?.data && (
                    <div className="d-flex align-items-center justify-content-end gap-4">
                      <button
                        className="btn btn-secondary px-5"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <button
                        disabled={pageStates?.isLoading}
                        type="submit"
                        className="btn btn-primary px-5"
                      >
                        {pageStates?.isLoading ? (
                          <Spinner size="sm" />
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <ConfirmModal
        modal={modal}
        toggle={toggleModal}
        title="Delete Salary Head"
        message="Are you sure you want to delete this salary head?"
        confirmHandler={handleRemoveSalaryHead}
      />

      <AddEarningModal
        modal={earningModal}
        toggle={toggleEarningModal}
        earningsList={pageStates?.earnings}
        selectedSalaryHeads={selectedSalaryHeads}
        selectedSiteId={selectedOfficeId}
        GetSalaryHead={GetSalaryHead}
        GetSiteSalaryHeadDetail={GetOfficeSalaryHeadDetail}
        modalData={modalData}
        setModalData={setModalData}
        isOffice={true}
      />

      <AddDeductionModal
        modal={deductionModal}
        toggle={toggleDeductionModal}
        deductionsList={pageStates?.deductions}
        selectedSalaryHeads={selectedSalaryHeads}
        selectedSiteId={selectedOfficeId}
        GetSalaryHead={GetSalaryHead}
        GetSiteSalaryHeadDetail={GetOfficeSalaryHeadDetail}
        modalData={modalData}
        setModalData={setModalData}
        isOffice={true}
      />
    </>
  );
}
